module.exports = __webpack_public_path__ + "static/product-direction-7c0b00c8a6b9af313915a7932df01dc3.png";